import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  getTravelDocumentSalesInput,
  getTravelDocumentsSalesInput,
  TravelDocumentSalesLiteModel,
  TravelDocumentSalesModel,
} from './model';

export function useGetTravelDocumentsSales(
  input?: getTravelDocumentsSalesInput,
  options?: UseQueryOptions<
    ExtendedApiResult<TravelDocumentSalesLiteModel[]>,
    ApiError
  >,
): UseQueryResult<ExtendedApiResult<TravelDocumentSalesLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['document-sales', input?.params],
      () =>
        QueryFetchFunction({
          url: 'document-sales',
          params: input?.params,
        }),
      options,
    ),
    TravelDocumentSalesLiteModel,
  );
}

export function useGetTravelDocumentSales(
  input?: getTravelDocumentSalesInput,
  options?: UseQueryOptions<ApiResult<TravelDocumentSalesModel>, ApiError>,
): UseQueryResult<ApiResult<TravelDocumentSalesModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['document-sales', input?.id],
      () =>
        QueryFetchFunction({
          url: `document-sales/${input?.id}`,
        }),
      options,
    ),
    TravelDocumentSalesModel,
  );
}

export function getTravelDocumentsSalesKey(
  input?: getTravelDocumentsSalesInput,
) {
  return ['document-sales', input?.params];
}

export function getTravelDocumentSalesKey(input?: getTravelDocumentSalesInput) {
  return ['document-sales', input?.id];
}
